/* =========================================
   UNTOLD STORY JEWELLERY — theme JS
   Ported from the static build. Cart and search now run on Shopify's own
   APIs; everything money-shaped is rendered by Liquid via the Section
   Rendering API rather than formatted in JavaScript.
   ========================================= */

(function () {
  'use strict';

  const routes = (window.theme && window.theme.routes) || {};
  const strings = (window.theme && window.theme.strings) || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ========== 1. SCROLL PROGRESS ========== */
  const scrollProgress = $('#scrollProgress');
  const updateScrollProgress = () => {
    if (!scrollProgress) return;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    scrollProgress.style.width = (docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0) + '%';
  };
  window.addEventListener('scroll', updateScrollProgress, { passive: true });
  updateScrollProgress();

  /* ========== 2. HEADER + BACK TO TOP ========== */
  const header = $('#navbar');
  const backToTop = $('#backToTop');

  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY > 50;
    if (header) header.classList.toggle('scrolled', scrolled);
    if (backToTop) backToTop.classList.toggle('visible', scrolled);
  }, { passive: true });

  backToTop?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  /* ========== 3. MOBILE NAV ========== */
  const mobileToggle = $('#mobileToggle');
  const mobileNav = $('#mobileNav');

  mobileToggle?.addEventListener('click', () => {
    const isActive = mobileToggle.classList.toggle('active');
    mobileNav?.classList.toggle('active', isActive);
    mobileToggle.setAttribute('aria-expanded', String(isActive));
  });

  mobileNav?.querySelectorAll('a, button').forEach((item) => {
    item.addEventListener('click', () => {
      mobileToggle?.classList.remove('active');
      mobileNav.classList.remove('active');
      mobileToggle?.setAttribute('aria-expanded', 'false');
    });
  });

  /* ========== 4. HERO SLIDER ========== */
  const heroSection = $('#hero');
  const heroSlides = $$('.hero-slide');
  const heroIndicators = $$('.page-indicator');
  const heroPrev = $('#heroPrev');
  const heroNext = $('#heroNext');
  const hasHero = heroSlides.length > 1 && heroPrev && heroNext;
  let currentSlide = 0;
  let heroAutoPlay;

  const goToSlide = (index) => {
    heroSlides.forEach((slide, i) => slide.classList.toggle('active', i === index));
    heroIndicators.forEach((indicator, i) => {
      indicator.classList.toggle('active', i === index);
      indicator.setAttribute('aria-selected', String(i === index));
    });
    currentSlide = index;
  };

  const nextSlide = () => goToSlide((currentSlide + 1) % heroSlides.length);
  const prevSlide = () => goToSlide((currentSlide - 1 + heroSlides.length) % heroSlides.length);
  const startHeroAutoPlay = () => { heroAutoPlay = setInterval(nextSlide, 6000); };
  const resetHeroAutoPlay = () => { clearInterval(heroAutoPlay); startHeroAutoPlay(); };

  if (hasHero) {
    heroNext.addEventListener('click', () => { nextSlide(); resetHeroAutoPlay(); });
    heroPrev.addEventListener('click', () => { prevSlide(); resetHeroAutoPlay(); });
    heroIndicators.forEach((indicator) => {
      indicator.addEventListener('click', () => {
        goToSlide(parseInt(indicator.dataset.slide, 10));
        resetHeroAutoPlay();
      });
    });
    startHeroAutoPlay();
    heroSection?.addEventListener('mouseenter', () => clearInterval(heroAutoPlay));
    heroSection?.addEventListener('mouseleave', startHeroAutoPlay);
  }

  /* ========== 5. REVEAL + STAGGER ========== */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
    // threshold 0, not a fraction. The ratio an IntersectionObserver reports is
    // the visible area over the element's OWN area, so an element taller than
    // ten viewports can never reach 0.1 no matter how far it is scrolled.
    // .article-shell wraps a whole article and runs to 11,462px: the most a
    // 1080px screen can ever show of it is 9.4%, so it stayed at opacity 0 and
    // the longest guides rendered as an empty burgundy page. rootMargin
    // already holds the reveal back until the element is 50px in, which is
    // what the fraction was reaching for. The static site has always used 0.
  }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });

  $$('.reveal').forEach((el) => revealObserver.observe(el));

  const staggerGroups = $$('.story-grid, .product-grid, .craft-grid, .insta-grid, .footer-links, .story-rows');
  staggerGroups.forEach((group) => {
    Array.from(group.children).forEach((child, i) => {
      child.classList.add('stagger-item');
      child.style.setProperty('--i', i);
    });
  });

  const staggerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('stagger-in');
        staggerObserver.unobserve(entry.target);
      }
    });
    // Same reasoning as the reveal observer above: these are grids, and a
    // stacked product or story grid on a phone is tall enough to hit the
    // same wall.
  }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

  staggerGroups.forEach((group) => staggerObserver.observe(group));

  /* ========== 6. ICON LINE-DRAW + IMAGE FADE ========== */
  $$('.craft-item svg path, .craft-item svg circle').forEach((shape) => {
    if (typeof shape.getTotalLength !== 'function') return;
    const len = Math.ceil(shape.getTotalLength());
    if (len) shape.style.setProperty('--len', len);
  });

  $$('.story-card img, .collection-img img, .product-card img, .insta-item img, .cat-image img, .statement-bg img')
    .forEach((img) => {
      if (img.complete && img.naturalWidth) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
        img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
      }
    });

  /* ========== 7. PARALLAX ========== */
  if (!reduceMotion) {
    const layers = [
      { container: heroSection, depth: 0.18, select: () => $('.hero-slide.active .hero-bg img') },
      { container: $('.premium-statement'), depth: 0.12, select: () => $('.statement-bg img') }
    ].filter((l) => l.container);

    let ticking = false;
    const render = () => {
      ticking = false;
      layers.forEach((layer) => {
        const box = layer.container.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        const el = layer.select();
        if (!el) return;
        const progress = (box.top + box.height / 2 - window.innerHeight / 2) / window.innerHeight;
        el.style.translate = `0 ${(-progress * layer.depth * box.height).toFixed(1)}px`;
      });
    };

    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(render); }
    }, { passive: true });
    render();
  }

  /* ========== 8. OVERLAY / MODAL MANAGER ========== */
  const overlay = $('#ui-overlay');
  const panels = {
    category: $('#category-modal'),
    search: $('#search-modal'),
    cart: $('#cart-drawer')
  };
  let lastFocused = null;

  const closeUI = () => {
    overlay?.classList.remove('is-active');
    Object.values(panels).forEach((p) => p?.classList.remove('is-active'));
    document.body.style.overflow = '';
    lastFocused?.focus();
    lastFocused = null;
  };

  const openPanel = (panel) => {
    if (!panel) return;
    /* Held in a local across closeUI, which focuses lastFocused and then
       nulls it. Assigning before that call meant the value was wiped on the
       way past, so closing the drawer never returned focus to the control
       that opened it. */
    const opener = document.activeElement;
    closeUI();
    lastFocused = opener;
    overlay?.classList.add('is-active');
    panel.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    const focusable = panel.querySelector('input, button, a[href]');
    focusable?.focus();
  };

  $$('.js-toggle-category').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openPanel(panels.category); }));
  $$('.js-toggle-search').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openPanel(panels.search); }));
  $$('.js-toggle-cart').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openPanel(panels.cart); }));

  overlay?.addEventListener('click', closeUI);
  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-close-ui')) closeUI();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeUI(); });

  /* ========== 9. TOASTS ========== */
  const toastContainer = $('#toastContainer');
  const showToast = (message) => {
    if (!toastContainer) return;
    const toast = document.createElement('div');
    toast.className = 'toast';
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('width', '16'); icon.setAttribute('height', '16');
    icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('fill', 'none');
    icon.setAttribute('stroke', 'currentColor'); icon.setAttribute('stroke-width', '2');
    icon.innerHTML = '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/>';
    const label = document.createElement('span');
    label.textContent = message;
    toast.append(icon, label);
    toastContainer.appendChild(toast);
    setTimeout(() => {
      toast.classList.add('out');
      setTimeout(() => toast.remove(), 400);
    }, 3000);
  };

  /* ========== 10. CART — Shopify AJAX + Section Rendering ========== */
  const cartDrawerId = 'cart-drawer';

  /* The cart page's section id is the section's own name, main-cart, not the
     key it has in templates/cart.json. Asking for "main" returns a 404 and
     the Section Rendering API just omits it from the response, so the swap
     below found nothing and the cart page silently never repainted: the row
     stayed on screen, dimmed, after the line had already left the cart.
     Verified against the live store: ?section_id=main is 404,
     ?section_id=main-cart is 200 and contains the wrapper.
     Only requested when that wrapper is actually on the page. */
  const cartPageId = 'main-cart';

  const cartSections = () => {
    const ids = [cartDrawerId];
    if (document.querySelector('[data-cart-page-inner]')) ids.push(cartPageId);
    return ids.join(',');
  };

  const swapInner = (html, selector) => {
    if (!html) return;
    const current = document.querySelector(selector);
    if (!current) return;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (next) current.innerHTML = next.innerHTML;
  };

  const paintCount = (count) => {
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  };

  /* Paints from a cart mutation response that already carries the rendered
     sections, so nothing further has to be fetched. Returns false when the
     response had no sections and the caller should fall back. */
  const paintCartFrom = (data) => {
    if (!data || !data.sections) return false;
    swapInner(data.sections[cartDrawerId], '[data-cart-drawer-inner]');
    swapInner(data.sections[cartPageId], '[data-cart-page-inner]');
    paintCount(data.item_count);
    return true;
  };

  /* Fallback for callers with no sections in hand. The two requests do not
     depend on each other, so they go together rather than one after the
     other. */
  const refreshCartUI = async () => {
    try {
      const [sectionRes, cartRes] = await Promise.all([
        fetch(`${routes.cart_url}?section_id=${cartDrawerId}`),
        fetch(`${routes.cart_url}.js`)
      ]);
      if (!sectionRes.ok) throw new Error('cart section');
      swapInner(await sectionRes.text(), '[data-cart-drawer-inner]');

      const pageInner = document.querySelector('[data-cart-page-inner]');
      if (pageInner) {
        const pageRes = await fetch(`${routes.cart_url}?section_id=${cartPageId}`);
        if (pageRes.ok) swapInner(await pageRes.text(), '[data-cart-page-inner]');
      }

      const cart = await cartRes.json();
      paintCount(cart.item_count);
    } catch (err) {
      console.error('[cart]', err);
      showToast(strings.cartError || 'Something went wrong.');
    }
  };

  /* Adding to the bag.

     This used to match .quick-add-form, which is the little + on a product
     card. The product page's own form never carried that class, so nothing
     here ran: the browser posted to /cart/add natively, Shopify answered with
     a redirect to /cart, and the whole page navigated away. That is why adding
     a piece appeared to have no animation and never showed in the bag. There
     was nothing wrong with the animation; the page it lived on was gone before
     it could play. Both forms now carry .ajax-cart-form.

     reportValidity is not belt and braces. The product form is rendered with
     novalidate, which switches off the browser's own constraint checking, so
     the required on the ring size input did nothing at all and a ring could be
     added with no size. Asking for validity explicitly puts that back, and
     shows the browser's message against the offending field. */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.ajax-cart-form');
    if (!form) return;
    e.preventDefault();

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    const button = form.querySelector('[data-quick-add], [type="submit"]');
    button?.setAttribute('disabled', 'disabled');
    try {
      const body = new URLSearchParams(new FormData(form));
      body.set('sections', cartSections());

      const res = await fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);

      /* Sections come back with the add, so the drawer repaints from this
         response. The count does not: /cart/add.js answers with the line it
         just added, not with cart totals. It has to be asked for separately
         and it has to be asked for *after* the add, not alongside it, or the
         reply is whatever the count was before this piece went in. */
      if (!paintCartFrom(data)) await refreshCartUI();
      try {
        const cartRes = await fetch(`${routes.cart_url}.js`);
        if (cartRes.ok) paintCount((await cartRes.json()).item_count);
      } catch (countErr) {
        console.error('[cart:count]', countErr);
      }

      showToast((strings.addedToCart || '{{ title }} added to cart').replace('{{ title }}', data.product_title || data.title || ''));
      openPanel(panels.cart);
    } catch (err) {
      console.error('[cart:add]', err);
      showToast(strings.cartError || 'Something went wrong.');
    } finally {
      button?.removeAttribute('disabled');
    }
  });

  /* Removing a line used to cost three round trips in the drawer (change,
     then the section, then the cart JSON) and a whole page navigation on the
     cart page, where the remove control was a plain link. Both felt broken.

     The Cart AJAX API renders sections for you if you ask: one POST now
     returns the new cart and the rendered markup together, so a remove is a
     single request. The row also dims the instant it is clicked, so the
     result is visible before the network has answered rather than after. */
  document.addEventListener('click', async (e) => {
    const control = e.target.closest('[data-line-change]');
    if (!control) return;
    e.preventDefault();
    if (control.dataset.busy) return;

    const line = control.dataset.line;
    const quantity = control.dataset.lineChange;
    const row = control.closest('.cart-item');

    control.dataset.busy = '1';
    if (row && Number(quantity) === 0) row.classList.add('is-removing');

    try {
      const res = await fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity),
          sections: cartSections()
        })
      });
      if (!res.ok) throw new Error('change');
      const data = await res.json();
      if (Number(quantity) === 0) showToast(strings.itemRemoved || 'Item removed');
      if (!paintCartFrom(data)) await refreshCartUI();
    } catch (err) {
      console.error('[cart:change]', err);
      row?.classList.remove('is-removing');
      delete control.dataset.busy;
      showToast(strings.cartError || 'Something went wrong.');
    }
  });

  /* ========== 11. PREDICTIVE SEARCH ========== */
  const searchForm = $('#searchForm');
  const searchInput = searchForm?.querySelector('input[type="search"], input[name="q"]');
  const searchResults = $('#searchResults');
  let searchTimer;

  const runSearch = async (term) => {
    if (!searchResults) return;
    if (!term || term.length < 2) { searchResults.innerHTML = ''; return; }
    try {
      const url = `${routes.predictive_search_url}?q=${encodeURIComponent(term)}`
        + `&resources[type]=product,article&resources[limit]=6&section_id=predictive-search`;
      const res = await fetch(url);
      if (!res.ok) throw new Error('search');
      const markup = await res.text();
      const fresh = new DOMParser().parseFromString(markup, 'text/html');
      const inner = fresh.querySelector('[data-predictive-results]');
      searchResults.innerHTML = inner ? inner.innerHTML : '';
    } catch (err) {
      console.error('[search]', err);
      searchResults.innerHTML = '';
    }
  };

  searchInput?.addEventListener('input', (e) => {
    clearTimeout(searchTimer);
    const term = e.target.value.trim();
    searchTimer = setTimeout(() => runSearch(term), 250);
  });

  $$('.search-tag').forEach((tag) => {
    tag.addEventListener('click', (e) => {
      e.preventDefault();
      if (!searchInput) return;
      searchInput.value = tag.textContent.trim();
      runSearch(searchInput.value);
    });
  });

  /* ========== 12. TESTIMONIALS ========== */
  const testimonialTrack = $('#testimonialTrack');
  const testimonialSlides = $$('.testimonial-slide');
  const testimonialDots = $$('.dot');
  let currentTestimonial = 0;

  const goToTestimonial = (index) => {
    if (!testimonialTrack) return;
    currentTestimonial = index;
    testimonialTrack.style.transform = `translateX(-${index * 100}%)`;
    testimonialDots.forEach((dot, i) => dot.classList.toggle('active', i === index));
    testimonialSlides.forEach((slide, i) => slide.classList.toggle('active', i === index));
  };

  testimonialDots.forEach((dot) => {
    dot.addEventListener('click', () => goToTestimonial(parseInt(dot.dataset.dot, 10)));
  });

  if (testimonialTrack && testimonialDots.length > 1) {
    goToTestimonial(0);
    setInterval(() => goToTestimonial((currentTestimonial + 1) % testimonialDots.length), 8000);
  }

  /* ========== 13. PRELOADER ========== */
  const dismissPreloader = () => document.body.classList.add('is-loaded');
  if (document.readyState === 'complete') {
    dismissPreloader();
  } else {
    window.addEventListener('load', dismissPreloader);
    setTimeout(dismissPreloader, 2200);
  }

  /* ========== 13B. STYLE QUIZ PROMPT ==========
     Ported from the static site's js/quiz-entry.js. Spec:
     docs/customer-experience-guide.md 7.2 - the prompt appears after 30
     seconds of browsing OR once two sections have been scrolled past,
     whichever lands first. Dismissing it silences it for the rest of the
     visit, not forever: sessionStorage, not localStorage, so a returning
     visitor is offered help again.

     The snippet renders nothing when there is no quiz page, so the guard
     below is the only thing needed for the feature to be genuinely absent. */
  (function quizPrompt() {
    const fab = document.getElementById('quizFab');
    if (!fab) return;

    const DELAY_MS = 30000;
    const SECTIONS_SEEN = 2;
    const DISMISS_KEY = 'us_quiz_fab_dismissed';

    let dismissed = false;
    try { dismissed = sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { /* private mode */ }
    if (dismissed) return;

    // Never offer the quiz to someone already taking it.
    if (window.location.pathname.indexOf(fab.getAttribute('href')) === 0) return;

    let shown = false;
    let observer = null;
    let timer = null;

    const cleanup = () => {
      clearTimeout(timer);
      if (observer) { observer.disconnect(); observer = null; }
    };

    const show = () => {
      if (shown) return;
      shown = true;
      fab.hidden = false;
      // Next frame, so the transition runs from the hidden state rather than
      // snapping straight to the visible one.
      requestAnimationFrame(() => requestAnimationFrame(() => fab.classList.add('is-visible')));
      cleanup();
    };

    const hide = () => {
      fab.classList.remove('is-visible');
      setTimeout(() => { fab.hidden = true; }, 500);
      try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* ignore */ }
    };

    timer = setTimeout(show, DELAY_MS);

    const sections = $$('main > section, main > div[id^="shopify-section"]');
    if (sections.length && 'IntersectionObserver' in window) {
      let seen = 0;
      // A section counts as seen when 40% of it is on screen OR when it fills
      // most of the screen. The second half matters: a ratio alone is measured
      // against the element's own height, so a section taller than 2.5
      // viewports can never reach 0.4 and would never count. That is the same
      // trap that left .article-shell invisible, and it is why the threshold
      // list starts at 0.
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const fillsScreen = entry.intersectionRect.height >= window.innerHeight * 0.6;
          if (entry.intersectionRatio < 0.4 && !fillsScreen) return;
          observer.unobserve(entry.target);
          seen += 1;
          if (seen >= SECTIONS_SEEN + 1) show(); // +1: the hero counts as the first
        });
      }, { threshold: [0, 0.4] });
      sections.forEach((s) => observer.observe(s));
    }

    const dismiss = document.getElementById('quizFabDismiss');
    if (dismiss) {
      const onDismiss = (e) => {
        e.preventDefault();
        e.stopPropagation();
        hide();
      };
      dismiss.addEventListener('click', onDismiss);
      dismiss.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') onDismiss(e);
      });
    }
  })();

  /* ========== 13C. CUSTOM ORDER -> WHATSAPP ==========
     The form posts to Shopify as a normal contact form so the enquiry is
     recorded whatever happens next, and WhatsApp opens with the same answers
     already written so the conversation starts where this shop actually talks
     to people.

     The window is opened inside the click handler, synchronously, because a
     pop-up opened later from an async callback is blocked by every browser.
     The form is then submitted natively, so Shopify's own validation and its
     success and error states still work exactly as they would without this.

     If any of it throws, or JavaScript never ran, the form still posts and the
     success message carries a WhatsApp link instead. Nothing is lost. */
  (function customOrderHandoff() {
    const btn = $('[data-co-submit]');
    if (!btn) return;
    const form = btn.closest('form');
    const number = btn.getAttribute('data-co-number');
    if (!form || !number) return;

    let handing = false;

    form.addEventListener('submit', (e) => {
      if (handing) return;
      // Let the browser show its own "this field is required" first.
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

      const val = (key) => {
        const el = $(`[data-co="${key}"]`, form);
        return el && el.value ? el.value.trim() : '';
      };

      const lines = [];
      const name = val('name');
      lines.push(name ? `Hello, this is ${name}.` : 'Hello.');
      lines.push('I would like to ask about a custom piece.');

      const detail = [
        ['What I have in mind', val('idea')],
        ['What it is for', val('occasion')],
        ['Needed by', val('when')],
        ['Budget', val('budget')]
      ].filter((pair) => pair[1]);

      if (detail.length) {
        lines.push('');
        detail.forEach((pair) => lines.push(`${pair[0]}: ${pair[1]}`));
      }

      let opened = null;
      try {
        opened = window.open(
          `https://wa.me/${number}?text=${encodeURIComponent(lines.join('\n'))}`,
          '_blank',
          'noopener'
        );
      } catch (err) {
        opened = null;
      }

      // Whether or not WhatsApp opened, the enquiry still has to reach the
      // shop. Submit natively so Shopify handles it from here.
      //
      // requestSubmit, never submit. Shopify protects storefront forms with
      // hCaptcha, and it fills the hidden h-captcha-response field from a
      // listener on the submit event. form.submit() is the one way to send a
      // form that skips submit listeners, so the token stayed empty and every
      // enquiry came back "Missing CAPTCHA token" and reached nobody.
      // requestSubmit fires the event properly; the handing flag below stops
      // this handler running a second time and lets the default through.
      e.preventDefault();
      handing = true;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }

      if (!opened) {
        // Pop-up blocked. The success page carries the link, so say nothing
        // here rather than throwing an alert at somebody mid-enquiry.
      }
    });
  })();

  /* ========== 13D. RING SIZE UNIT ==========
     A ring is 12-25mm inside the band, which is 1.2-2.5cm. One set of min
     and max cannot cover both, and "17" with cm selected is a ring the size
     of a bracelet. Swap the bounds with the unit so the browser's own
     validation catches it, and rescale a value already typed rather than
     leaving a number that is now out of range sitting in the field.

     Progressive enhancement only. With this script blocked the field is
     still type=number and still required; it just accepts a wider range. */
  (function ringSizeUnit() {
    const input = $('[data-ring-size]');
    const unit = $('[data-ring-size-unit]');
    if (!input || !unit) return;

    const BOUNDS = { mm: [12, 25, '0.1'], cm: [1.2, 2.5, '0.01'] };

    unit.addEventListener('change', () => {
      const from = unit.dataset.previous || 'mm';
      const to = unit.value;
      const b = BOUNDS[to];
      if (!b) return;

      if (input.value !== '' && from !== to) {
        const n = parseFloat(input.value);
        if (!Number.isNaN(n)) {
          const converted = to === 'cm' ? n / 10 : n * 10;
          input.value = to === 'cm' ? converted.toFixed(2) : converted.toFixed(1);
        }
      }

      input.min = b[0];
      input.max = b[1];
      input.step = b[2];
      unit.dataset.previous = to;
    });

    unit.dataset.previous = unit.value;
  })();

  /* ========== 13E. PRODUCT GALLERY ==========
     This did not exist. The thumbnails rendered, carried a data-media-id and
     had an .is-active style waiting for them in the CSS, but nothing ever
     listened for a click, so the gallery was stuck on the first image and a
     customer could not see the other photographs of a piece at all.

     Delegated from the gallery element rather than bound per thumbnail, so
     it survives the section being re-rendered in the theme editor. The
     thumbs are real <button>s, so Enter and Space already work. */
  (function productGallery() {
    const gallery = $('.product-gallery');
    if (!gallery) return;

    const slides = $$('[data-gallery-slide]', gallery);
    const thumbs = $$('[data-gallery-thumb]', gallery);
    if (slides.length < 2 || !thumbs.length) return;

    const show = (id) => {
      if (!id) return;
      /* Resolve before touching anything. Toggling first and bailing out
         afterwards would clear every slide and leave the gallery blank on a
         thumbnail whose slide is missing. */
      const target = slides.find((slide) => slide.dataset.mediaId === id);
      if (!target) return;

      slides.forEach((slide) => slide.classList.toggle('is-active', slide === target));
      thumbs.forEach((thumb) => {
        const on = thumb.dataset.mediaId === id;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };

    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb || !gallery.contains(thumb)) return;
      e.preventDefault();
      show(thumb.dataset.mediaId);
    });
  })();

  /* ========== 14. THEME EDITOR ========== */
  document.addEventListener('shopify:section:load', () => {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
    $$('.story-grid, .product-grid, .craft-grid, .insta-grid, .story-rows')
      .forEach((g) => g.classList.add('stagger-in'));
  });
})();

/* ---------------------------------------------------------------------------
   Copy buttons on contact details.

   Mirrors the static site: the clipboard API needs a secure context, so when
   it is unavailable the text is selected instead. Never leaves the customer
   with a button that appears to do nothing.
--------------------------------------------------------------------------- */
(function () {
  var buttons = document.querySelectorAll('.contact-copy[data-copy]');
  if (!buttons.length) return;

  function copy(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = value;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      } finally {
        area.remove();
      }
    });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var original = btn.textContent;
      copy(btn.dataset.copy).then(function () {
        btn.textContent = btn.dataset.copiedLabel || 'Copied';
        btn.classList.add('is-copied');
      }).catch(function () {
        var target = btn.previousElementSibling;
        if (!target) return;
        var range = document.createRange();
        range.selectNodeContents(target);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        btn.textContent = 'Select it';
      }).then(function () {
        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('is-copied');
        }, 2000);
      });
    });
  });
})();
